import React, {  useState, useRef } from "react";
import HeaderNormal from "../components/HeaderNormal";
import '../styles/Contact.css'
import Footer from '../components/Footer'

const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://mys-back.onrender.com";

const Contact = () => {
   const [formData, setFormData] = useState({
    name: '',
    email: '',
    type: '',
    message: '',
  });


  const [loading, setLoading] = useState(false);
  const [ok, setOk] = useState(false);
  const [err, setErr] = useState("");
  const [startMs] = useState(() => Date.now());
  const honeypotRef = useRef(null);
  
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setOk(false);

    // Anti-bot simples
    if (honeypotRef.current?.value) {
      setErr("Envoi bloqué.");
      return;
    }
    if (Date.now() - startMs < 3000) {
      setErr("Merci de patienter quelques secondes et réessayer.");
      return;
    }

    setLoading(true);
    try {
      const r = await fetch(`${API_BASE}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          honey: honeypotRef.current?.value || "",
          t: startMs,
        }),
      });
      const data = await r.json().catch(() => ({ ok: false, error: "Réponse invalide" }));
      if (!r.ok || !data.ok) throw new Error(data.error || "Envoi impossible");
      setOk(true);
      setFormData({ name: "", email: "", type: "", message: "" });
    } catch (e) {
      setErr(e.message || "Une erreur est survenue.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <HeaderNormal />
    <div className="contact">
          <h1>⚓ Nous <span>contacter</span>⚓</h1>
      <div className="contact-container">
        <form onSubmit={handleSubmit} noValidate>
            {/* Honeypot (caché) */}
            <input
              ref={honeypotRef}
              type="text"
              name="company"
              autoComplete="off"
              tabIndex={-1}
              className="hp"
              aria-hidden="true"
            />

          <label htmlFor="name">Nom complet :</label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Jean Marin"
            value={formData.name}
            onChange={handleChange}
            required
            minLength={2}
            maxLength={120}
          />

          <label htmlFor="email">Adresse e-mail :</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="jean@exemple.com"
            value={formData.email}
            onChange={handleChange}
            required
            maxLength={150}
          />

          <label htmlFor="type">Type de contact :</label>
          <select
            id="type"
            name="type"
            value={formData.type}
            onChange={handleChange}
            required
          >
            <option value="">-- Choisir un motif --</option>
            <option value="rdv">Prise de rdv</option>
            <option value="info">Demande d'information générale</option>
            <option value="partenaire">Demande de partenariat</option>
            <option value="maintenance">Maintenance / assistance technique</option>
            <option value="autre">Autre demande</option>
          </select>

          <label htmlFor="message">Message :</label>
          <textarea
            id="message"
            name="message"
            placeholder="Votre message ici... max : 5000"
            value={formData.message}
            onChange={handleChange}
            required
            minLength={10}
            maxLength={5000}
          ></textarea>

          <button type="submit" disabled={loading} >
            {loading ? "Envoi..." : "Envoyer ma demande 🛟"}
          </button>
          {ok && <p className="ok">Message envoyé avec succès !</p>}
          {err && <p className="err">{err}</p>}
        </form>
      </div>
    </div>
    <Footer />
      </>
  );

};

export default Contact;
